export function validateStringArray(array: string[]): boolean{
  let notErrors = true;
  array.forEach((value) => { notErrors = !(value.length < 4) })
  return notErrors
}